module.exports = __webpack_public_path__ + "static/media/Roll-On Gel Mockup (3 bottles-Trans)-25percent.9c3090cf.svg";